import React, { Component } from 'react';
// 3rd Party
import { Col } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import v4 from 'uuid';
// Styles
import './IconBlock.css';

class IconBlock extends Component {
  state = {};

  render() {
    return (
      <Col md={4} className="IconBlock">
        <p className="lead">
          <FontAwesome
            name={this.props.classNmStr}
            size='8x'
          />
        </p>
        {
          this.props.description
          .map((descriptionStr) => (
            <p
              key={v4()}
              className="lead description">
              {descriptionStr}
            </p>
          ))
        }
      </Col>
    );
  }
}

export default IconBlock;



// WEBPACK FOOTER //
// ./src/presentationComponents/IconBlock.js